export default __webpack_public_path__ + "static/media/globe.55bc80d9.svg";